<template>
	<div class="sport-list-loader">
		<content-loader
			:width="320"
			:height="63"
			:speed="3"
			:primaryColor="primaryColor"
			:secondaryColor="secondaryColor"
		>
			<rect x="0" y="0" rx="0" ry="0" width="53" height="53" />
			<rect x="80" y="0" rx="0" ry="0" width="53" height="53" />
			<rect x="160" y="0" rx="0" ry="0" width="53" height="53" />
			<rect x="240" y="0" rx="0" ry="0" width="53" height="53" />
		</content-loader>
	</div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
	components: { ContentLoader },
	computed: {
		primaryColor() {
			return window
				.getComputedStyle(document.body)
				.getPropertyValue("--light-gray")
				.replace(" ", "");
		},
		secondaryColor() {
			return window
				.getComputedStyle(document.body)
				.getPropertyValue("--main-bg-color")
				.replace(" ", "");
		},
	},
};
</script>

<style lang="scss" scoped>
.sport-list-loader {
	padding: 10px;
	background: var(--main-bg-color);
}
</style>
